var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "37px",
    viewBox: "0 0 114 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-134,-208 L246,-208 C248.761424,-208 251,-205.761424 251,-203 L251,32 C251,34.7614237 248.761424,37 246,37 L141,37 L141,37 C131,37 119.333333,37 106,37 C86,37 88.5,6.5 56,6.5 C23.5,6.5 26,37 6,37 C-7.33333333,37 -19,37 -29,37 L-134,37 C-136.761424,37 -139,34.7614237 -139,32 L-139,-203 C-139,-205.761424 -136.761424,-208 -134,-208 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.9%",
    width: "107.4%",
    height: "111.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0498251748 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBED",
    strokeWidth: 1,
    d: "M246,-207.5 C247.242641,-207.5 248.367641,-206.99632 249.181981,-206.181981 C249.99632,-205.367641 250.5,-204.242641 250.5,-203 L250.5,-203 L250.5,32 C250.5,33.2426407 249.99632,34.3676407 249.181981,35.1819805 C248.367641,35.9963203 247.242641,36.5 246,36.5 L246,36.5 L106,36.5 C97.3754107,36.5 93.0540119,30.6599327 88.1824959,24.1985017 C81.7536029,15.671413 74.4297606,6 56,6 C37.5702394,6 30.2463971,15.671413 23.8175041,24.1985017 C18.9459881,30.6599327 14.6245893,36.5 6,36.5 L6,36.5 L-134,36.5 C-135.242641,36.5 -136.367641,35.9963203 -137.181981,35.1819805 C-137.99632,34.3676407 -138.5,33.2426407 -138.5,32 L-138.5,32 L-138.5,-203 C-138.5,-204.242641 -137.99632,-205.367641 -137.181981,-206.181981 C-136.367641,-206.99632 -135.242641,-207.5 -134,-207.5 L-134,-207.5 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlope);
export default __webpack_public_path__ + "static/media/slope.c97b5b0983ff465e31787cd48f4a23ac.svg";
export { ForwardRef as ReactComponent };